import React, { createContext, useContext, useMemo, useState } from 'react';

const AdminContext = createContext();

export const useAdminContext = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdminContext must be used within AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeCity, setActiveCity] = useState('Hyderabad');
  const [geoFenceEnabled, setGeoFenceEnabled] = useState(true);
  const [deliveryBoyPool, setDeliveryBoyPool] = useState([]);
  const [selectedDeliveryBoy, setSelectedDeliveryBoy] = useState(null);
  const [locationDeliveryPrice, setLocationDeliveryPrice] = useState({});
  const [couponRules, setCouponRules] = useState([]);
  const [gstPercentage, setGstPercentage] = useState(5);

  const value = useMemo(
    () => ({
      sidebarOpen,
      setSidebarOpen,
      activeCity,
      setActiveCity,
      geoFenceEnabled,
      setGeoFenceEnabled,
      deliveryBoyPool,
      setDeliveryBoyPool,
      selectedDeliveryBoy,
      setSelectedDeliveryBoy,
      locationDeliveryPrice,
      setLocationDeliveryPrice,
      couponRules,
      setCouponRules,
      gstPercentage,
      setGstPercentage,
    }),
    [sidebarOpen, activeCity, geoFenceEnabled, deliveryBoyPool, selectedDeliveryBoy, locationDeliveryPrice, couponRules, gstPercentage]
  );

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
};
